export default __webpack_public_path__ + "static/media/src3_melodyne.99fe7341.mp3";